namespace Portico.Controllers {

    import Inject = Portico.Decorators.Inject;
    import Controller = Portico.Decorators.Controller;

    import pm = Portico.Models;
    import pmi = Portico.Models.Interfaces;
	import ps = Portico.Services;
	import pt = Portico.Tfs;

    @Controller('app', 'appController')
    @Inject(
        '$interval',
        '$scope',
        '$location',
        'actionService',
        'dataService',
        'enterpriseService',
        'modalService',
        'porticoService',
        'serverConstants',
        'dateService',
        'tfsService',
        'storageService')
    export class AppController {
        today: Date;
        rootUrl: string;

        constructor(
            private $interval: angular.IIntervalService,
            private $scope: angular.IScope,
            private $location: angular.ILocationService,
            private actionService: ps.IActionService,
            private dataService: ps.IDataService,
            private enterpriseService: ps.IEnterpriseService,
            private modalService: ps.IModalService,
            private porticoService: ps.IPorticoService,
            private serverConstants: pmi.IServerConstants,
            private dateService: ps.IDateService,
            private tfsService: pt.TfsService,
			private storageService: ps.StorageService
        ) {
			this.today = new Date();
			this.rootUrl = _.trimEnd(window.location.origin + window.location.pathname, '/') + '/';

            $interval(() => {
                const currentSession = this.storageService.getItem(pm.StorageType.Session, pm.SESSION_STORAGE_KEY) as pm.SessionDetail;

                if (currentSession) {
                    if (currentSession.status === Models.SESSION_ACTIVE) {
                        const now = new Date();

                        now.setMinutes(now.getMinutes() + 5);

                        if (currentSession.expirationDate <= now) {
                            currentSession.status = Models.SESSION_EXPIRING;
                            this.storageService.saveItem(Models.StorageType.Session, pm.SESSION_STORAGE_KEY, currentSession);
							this.porticoService.modalService.show2(this.$scope, 'session-inactivity', 'modal-primary', '');
                        }
                    } else if (currentSession.status === Models.SESSION_EXPIRING) {
                        const now = new Date();

                        if (currentSession.expirationDate <= now) {
                            currentSession.status = Models.SESSION_EXPIRED;
                            this.storageService.saveItem(Models.StorageType.Session, pm.SESSION_STORAGE_KEY, currentSession);
							this.porticoService.page('expired');
                        }
                    }
                }
            }, 500);
        }

		getDate() {
			return new Date();
		}
    }
}